export const baseUrl = "https://api.youthfp.cm/";
//export const baseUrl = "http://localhost:8087/"; 